import React from 'react';
import { DateRangePicker } from 'mui-daterange-picker';
import { Box } from '@mui/material';

interface DateRangePickerWrapperProps {
  open: boolean;
  toggle: () => void;
  onChange: (range: any) => void;
  initialDateRange: any;
}

/**
 * Wrapper component for mui-daterange-picker
 * Hides dates from adjacent months to prevent user confusion
 */
const DateRangePickerWrapper: React.FC<DateRangePickerWrapperProps> = ({
  open,
  toggle,
  onChange,
  initialDateRange
}) => {
  return (
    <Box
      sx={{
        '& .MuiCalendarPicker-root': {
          // Target the calendar picker root
        },
        // Hide dates from previous/next months that appear in current month view
        '& .MuiPickersDay-root.MuiPickersDay-dayOutsideMonth': {
          visibility: 'hidden',
          pointerEvents: 'none',
        },
        // Alternative selector for older MUI versions
        '& .MuiPickersDay-dayOutsideMonth': {
          visibility: 'hidden',
          pointerEvents: 'none',
        },
        // Target dates that are not in the current month
        '& [class*="dayOutsideMonth"]': {
          visibility: 'hidden',
          pointerEvents: 'none',
        },
        // Additional targeting for mui-daterange-picker specific classes
        '& .MuiButtonBase-root[disabled]:not(.Mui-selected)': {
          '&:not([class*="today"])': {
            opacity: 0,
          }
        },
      }}
    >
      <DateRangePicker
        open={open}
        toggle={toggle}
        onChange={onChange}
        initialDateRange={initialDateRange}
      />
    </Box>
  );
};

export default DateRangePickerWrapper;
